import { TextFilterType } from '../../../../../types';
import { OperationType } from '../../../../../main/operations/operationsTypes';

export type UniversalFilterOperationTypeStatus = OperationType;

export const enum UniversalFilterOperationTypeModes {
  IS_ANY_OF = 'is_any_of',
  IS_NONE_OF = 'is_none_of'
}

export type UniversalFilterOperationTypeValue = TextFilterType;

export type UniversalFilterOperationTypeFilterState = {
  mode: UniversalFilterOperationTypeModes;
  states?: UniversalFilterOperationTypeStatus[];
};

export type UniversalFilterOperationTypeOnFilterStateChange = (
  state: UniversalFilterOperationTypeFilterState
) => void;

export type UniversalFilterOperationTypeOnChange = (
  value?: UniversalFilterOperationTypeValue
) => void;
